
const styles= () => ({
    treeItem: {
        '&::after':{
            content: "''",
            width: "1px",
            height: "100%",
            backgroundColor: "#b4b4b4",
            position: "absolute",
            top: "0",
            bottom: "0",
            left: "0"
        },
        border: "1px solid red"
    },
    treeViewContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    treeView: {
      flexGrow: 1,
    }
  })

  export default styles
